// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuditExportController from "./audit_export_controller"
application.register("audit-export", AuditExportController)

import BulkEditController from "./bulk_edit_controller"
application.register("bulk-edit", BulkEditController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownEditController from "./dropdown_edit_controller"
application.register("dropdown-edit", DropdownEditController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalNotesController from "./modal_notes_controller"
application.register("modal-notes", ModalNotesController)

import MultiStagePreloaderController from "./multi_stage_preloader_controller"
application.register("multi-stage-preloader", MultiStagePreloaderController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import RecommendationListController from "./recommendation_list_controller"
application.register("recommendation-list", RecommendationListController)

import SummarizeController from "./summarize_controller"
application.register("summarize", SummarizeController)

import TextEditController from "./text_edit_controller"
application.register("text-edit", TextEditController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
